<template>
  <div id="newsdetails">
    <div class="news-bd" style="min-height: 350px;">
      <div class="top_back">
        <span @click="$router.back()">返回上一页</span>
      </div>
      <div class="news-l 1">
        <div class="d_title">{{title}}</div>
        <div class="news-l-bd" v-html="info"></div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>

export default {
  name: "Protocol",
  data() {
    return {
      info: ""
    };
  },
  components: {
  },
  computed: {
    title() {
      if (this.$route.params.type == 1) {
        return "注册协议";
      } else if (this.$route.params.type == 2) {
        return "风险揭示书";
      } else {
        return "好友现金券使用须知";
      }
    }
  },
  mounted() {
    let that = this;
    that
      .$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "protocol",
          type: that.$route.params.type
        }
      })
      .then(function(res) {
        if (res.data.code == 1) {
          that.info = res.data.data;
        } else if (res.data.code == 0 || res.data.code == -1) {
          that.$message.error(res.data.msg);
        }
      });
  },
  methods: {}
};
</script>
<style scoped>
@import url("./../assets/css/aboutus.css");
@import url("./../assets/css/news.css");
.top_back {
  width: 950px;
  margin: 0 auto;
  color: #333;
  padding: 30px 0 6px;
  /* font-size: 14px; */
}
.top_back span {
  cursor: pointer;
}
.news-l {
  float: none;
  display: block;
  margin: 0 auto;
  border: 1px solid #ccc;
  padding: 0 16px 20px;
}
.d_title {
  font-size: 24px;
  text-align: center;
  padding: 30px 0 30px;
}
</style>





// WEBPACK FOOTER //
// src/components/protocol.vue